export default __webpack_public_path__ + "static/media/pen.ba518efe.svg";